module.exports = __webpack_public_path__ + "static/img/e-auction.a8de6ead.png";